import React from 'react'
import styled from 'styled-components'
import { device } from '../../../config/theme/breakpoints'
import { UserPlus } from '@styled-icons/boxicons-regular'
import { RecordCircleFill } from '@styled-icons/bootstrap'
import { ThreeDotsVertical } from '@styled-icons/bootstrap'
import { LocationDot } from '@styled-icons/fa-solid'
import { Clock } from '@styled-icons/bootstrap'
import { ArrowRight } from '@styled-icons/bootstrap'
import FormUserItem from './components/form-user-item/form-user-item'

const ContainerDestinations = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 20px;
`

const ContainerDestiny = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    padding: 15px 12px;
`
const ContainerIcons = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 10px;
    margin-right: 5px;

    > svg {
        max-width: 10px;

        :nth-child(1){
            color: ${p => p.theme.palette.text.secondary};
        }
        :nth-child(2){
            color: ${p => p.theme.palette.text.primary};
            margin-top: 5px;
            margin-bottom: 5px;
        }
        :nth-child(3){
            color: ${p => p.theme.palette.text.primary};
        }
    }
`
const ContainerText = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    > div {
        font-size: 12px;
    }
    
    > div b {
        margin-right: 10px;
    }
`
const ContainerDuration = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    
    > svg {
        max-width: 12px;
        color: ${p => p.theme.palette.text.primary};
        margin-right: 5px;
    }

    > p {
        font-size: 12px;
        color: ${p => p.theme.palette.text.gray};
    }
`

const ContainerSummary = styled.div`
  width: 100%;

  @media ${device.tablet}{
    width: 30%;
  }
`
const ContainerDataSummary = styled.div`
  background: ${p => p.theme.palette.text.grayFullLight};
  border-radius: 20px;
`

const ContainerTopRight = styled.div`
  background: ${p => p.theme.palette.text.gray};
  border-radius: 20px 20px 0 0;
  color: white;
  text-align: center;
  font-size: 13px;
  padding: 4px;
`
const ContainerInfo = styled.div``
const ContainerInfoUsers = styled.div`
  width: 100%;
  background: white;
  padding 15px 12px;

  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    padding 8px 0;

    > p{
      margin: 0;
    }
    
    > p:nth-child(2){
      color: ${p => p.theme.palette.text.grayLight};
    }
  }
`

const ContainerTotal = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: space-around;
  align-items: center;
  padding: 15px 10px;

  > div {
    width: 50%;
  }

  > div h2, 
  > div h4,
  > div p {
    margin: 0;
  }

  > div h4 {
    color: ${p => p.theme.palette.text.gray};
    font-size: 15px;
  }
  
  > div p {
    color: ${p => p.theme.palette.text.grayLight};
    font-size: 12px;
  }

  > div h2 {
    color: ${p => p.theme.palette.secondary.main};
    font-size: 25px;
    text-align: center;
  }

  @media ${device.tablet}{
    > div {
      width: 100%;
    }
  }
`

const ContainerBottomRight = styled.div`
  border-radius: 0 0 20px 20px;
  background: ${p => p.theme.palette.primary.main};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  cursor: pointer;

  > svg{
    max-width: 20px;
    color: white;
  }

  > p {
    color: white;
    font-size: 15px;
  }

  :hover {
    background: #1EDE91;
  }
`

const ContainerTextTop = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  gap: 20px;
  flex-wrap: wrap;

  > h3 {
    color:  ${p => p.theme.palette.primary.main};
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;

    @media ${device.tablet}{
      width: 48%;
      justify-content: flex-end;
    }
  }

  > h3 svg {
    width: 20px;
    color:  ${p => p.theme.palette.secondary.main};
    margin: 0 10px;
  }

  > p{
    color:  ${p => p.theme.palette.text.grayLight};
    font-size: 12px;
    margin: 0;
    width: 100%;
    text-align: center;

    @media ${device.tablet}{
      width: 48%;
      text-align: left;
    }
  }
`
const ContainerFormUser = styled.div`
    width: 100%;

    @media ${device.tablet}{
        width: 65%;
    }
`

interface IOwnProps {
  onClick: (step: number) => void
}

const UsersDetailComponent: React.FunctionComponent<IOwnProps> = ({ onClick }) => {
  return (
    <>
      <ContainerTextTop>
        <h3>
          Lima
          <ArrowRight />
          Chiclayo
        </h3>
        <p>Miercoles 10 de Agosto</p>
      </ContainerTextTop>
      <ContainerDestinations>
        <ContainerFormUser>
            <FormUserItem nro='1'/>
            <FormUserItem nro='2'/>
            <FormUserItem nro='3'/>
        </ContainerFormUser>
        <ContainerSummary>
            <ContainerDataSummary>
              <ContainerTopRight><p><b>Buscama</b> 160º / 140º</p></ContainerTopRight>
              <ContainerInfo>
                <ContainerDestiny>
                    <ContainerIcons>
                        <RecordCircleFill />
                        <ThreeDotsVertical />
                        <LocationDot />
                    </ContainerIcons>
                    <ContainerText>
                        <div><b>09:00 am</b>Lima - Plaza Norte</div>
                        <div><b>06:20 pm</b>Chiclayo</div>
                    </ContainerText>
                    <ContainerDuration>
                        <Clock />
                        <p>Duración: 15 Hrs. 30 Min. Aproximadamente</p>
                    </ContainerDuration>
                </ContainerDestiny>
              </ContainerInfo>
              <ContainerInfoUsers>
                <div>
                  <p><b>Pasajero Nº</b></p>
                  <p>S/ 100.00</p>
                </div>
                <div>
                  <p><b>Pasajero Nº</b></p>
                  <p>S/ 100.00</p>
                </div>
                <div>
                  <p><b>Pasajero Nº</b></p>
                  <p>S/ 100.00</p>
                </div>
                <div>
                  <p><b>Pasajero Nº</b></p>
                  <p>S/ 100.00</p>
                </div>
              </ContainerInfoUsers>
              <ContainerTotal>
                <div>
                  <h4>Precio Total</h4>
                  <p>Tasas e impuestos incluidos</p>
                </div>
                <div>
                  <h2>S/ 400.00</h2>
                </div>
              </ContainerTotal>
              <ContainerBottomRight onClick={() => onClick(4)}>
                <p>Realizar el pago</p>
                <UserPlus />
              </ContainerBottomRight>
            </ContainerDataSummary>
        </ContainerSummary>
      </ContainerDestinations>
    </>
  )
}

export default UsersDetailComponent